import { supabase } from './supabase';
import type { VisionBoardBackground } from './api';

export type NewVisionBoardBackground = Omit<
  VisionBoardBackground,
  'id' | 'created_at'
>;

const TABLE = 'vision_board_backgrounds';

export async function listVisionBoardBackgrounds(): Promise<
  VisionBoardBackground[]
> {
  const { data, error } = await supabase
    .from(TABLE)
    .select('*')
    .order('created_at', { ascending: false });

  if (error) throw error;
  return (data as VisionBoardBackground[]) || [];
}

export async function createVisionBoardBackground(
  input: NewVisionBoardBackground
): Promise<VisionBoardBackground> {
  const payload = {
    title: input.title,
    image_url: input.image_url,
    active: input.active,
    is_default: input.is_default,
    default_display: input.default_display,
  };

  const { data, error } = await supabase
    .from(TABLE)
    .insert(payload)
    .select('*')
    .single();

  if (error) throw error;
  return data as VisionBoardBackground;
}

export async function updateVisionBoardBackground(
  id: string,
  input: NewVisionBoardBackground
): Promise<VisionBoardBackground> {
  const payload = {
    title: input.title,
    image_url: input.image_url,
    active: input.active,
    is_default: input.is_default,
    default_display: input.default_display,
  };

  const { data, error } = await supabase
    .from(TABLE)
    .update(payload)
    .eq('id', id)
    .select('*')
    .single();

  if (error) throw error;
  return data as VisionBoardBackground;
}

export async function setVisionBoardBackgroundDefault(
  id: string
): Promise<VisionBoardBackground> {
  const { error: clearError } = await supabase
    .from(TABLE)
    .update({ is_default: false })
    .eq('is_default', true);

  if (clearError) throw clearError;

  const { data, error } = await supabase
    .from(TABLE)
    .update({ is_default: true, active: true })
    .eq('id', id)
    .select('*')
    .single();

  if (error) throw error;
  return data as VisionBoardBackground;
}

export async function deleteVisionBoardBackground(id: string): Promise<void> {
  const { error } = await supabase.from(TABLE).delete().eq('id', id);

  if (error) throw error;
}
